"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiPaginationTableHead = _interopRequireDefault(require("./components/MuiPaginationTableHead/MuiPaginationTableHead"));

var _MuiPaginationTableBody = _interopRequireDefault(require("./components/MuiPaginationTableBody/MuiPaginationTableBody"));

var _MuiPaginationTableFooter = _interopRequireDefault(require("./components/MuiPaginationTableFooter/MuiPaginationTableFooter"));

var MuiPaginationTable = function MuiPaginationTable(_ref) {
  var rootClass = _ref.rootClass,
      padding = _ref.padding,
      size = _ref.size,
      stickyHeader = _ref.stickyHeader,
      tHead = _ref.tHead,
      tBody = _ref.tBody,
      labelRowsPerPage = _ref.labelRowsPerPage,
      rowsPerPageOptions = _ref.rowsPerPageOptions;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var parsedRowsPerPageOptions = rowsPerPageOptions.map(function (num) {
    return +num;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      numRows = _useState2[0],
      setNumRows = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = (0, _react.useState)(parsedRowsPerPageOptions[0]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var handleRowNums = function handleRowNums(totalRows) {
    setNumRows(totalRows);
  };

  var handlePageChange = function handlePageChange(e, newPage) {
    setPage(newPage);
  };

  var handleChangeRows = function handleChangeRows(e) {
    var value = e.target.value;
    setRowsPerPage(parseInt(value, 10));
    setPage(0);
  };

  return /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: styles.root,
    padding: padding,
    size: size,
    stickyHeader: stickyHeader
  }, /*#__PURE__*/_react.default.createElement(_MuiPaginationTableHead.default, tHead[0]), /*#__PURE__*/_react.default.createElement(_MuiPaginationTableBody.default, (0, _extends2.default)({}, tBody[0], {
    handleRowNums: handleRowNums,
    numRows: numRows,
    rowsPerPage: parseInt(rowsPerPage, 10),
    page: page
  })), /*#__PURE__*/_react.default.createElement(_MuiPaginationTableFooter.default, {
    labelRowsPerPage: labelRowsPerPage,
    rowsPerPageOptions: parsedRowsPerPageOptions,
    numRows: numRows,
    page: page,
    handleChangeRows: handleChangeRows,
    rowsPerPage: parseInt(rowsPerPage, 10),
    handlePageChange: handlePageChange
  }));
};

var _default = MuiPaginationTable;
exports.default = _default;
MuiPaginationTable.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'default' | 'checkbox' | 'none'
   * Allows TableCells to inherit padding of the Table.
   */
  padding: function padding(props, propName, componentName) {
    var validProps = ['default', 'checkbox', 'none'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui props: 'small' | 'medium'
   * Allows TableCells to inherit size of the Table.
   */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui props: true | false
   * set the header sticky. (It doesn't work with IE 11)
   */
  stickyHeader: _propTypes.default.bool,

  /**  MuiPaginationTableHead limit of 1 */
  tHead: function tHead(props, propName, componentName) {
    var components = ['MuiPaginationTableHead'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**  MuiPaginationTableBody limit of 1 */
  tBody: function tBody(props, propName, componentName) {
    var components = ['MuiPaginationTableBody'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * mui prop: 'Rows per page:'
   * Customize the rows per page label.
   */
  labelRowsPerPage: _propTypes.default.node,

  /**
   * mui prop: [10, 25, 50, 100]
   * Customizes the options of the rows per page select field.
   * If less than two options are available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes.default.arrayOf(_propTypes.default.string)
};
MuiPaginationTable.defaultProps = {
  padding: 'default',
  size: 'medium',
  stickyHeader: false,
  rootClass: [],
  tBody: [],
  tHead: [],
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [10, 25, 50, 100]
};